import React from 'react';
import { Container, Navbar, Nav, NavDropdown, Alert } from 'react-bootstrap';
import VersionIndicator from './VersionIndicator';
import '../custom-navbar.css';
import { hasModulePermission, hasPermission, hasFeatureSubscription } from '../utils/permissionUtils.js';

const AppNavbar = ({ currentView, setCurrentView, user, handleLogout, versionInfo }) => {
  const userPermissions = JSON.parse(sessionStorage.getItem('userPermissions') || '[]');
  //console.log('User Permissions in AppNavbar:', userPermissions);
  return (
    <>
      <Navbar expand="lg" sticky="top" className="custom-navbar">
        <Container fluid>
          <Navbar.Brand href="#" onClick={() => setCurrentView('dashboard')} className="custom-navbar-brand">
            <i className="bi bi-building me-2"></i>
            {process.env.REACT_APP_TITLE}
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="me-auto">
              <Nav.Link
                active={currentView === 'dashboard'}
                onClick={() => setCurrentView('dashboard')}
              >
                <i className="bi bi-speedometer2 me-1"></i> Dashboard
              </Nav.Link>
              {hasModulePermission(userPermissions, '_MODULE_PLATFORM_') && (
                <NavDropdown title={<><i className="bi bi-cpu me-1"></i> Platform</>} id="platform-dropdown">
                  {hasPermission(userPermissions, '_SECTION_ORGANIZATION_') && (
                    <NavDropdown.Item active={currentView === 'organizations'} onClick={() => setCurrentView('organizations')}>
                      <i className="bi bi-buildings me-1"></i> Organizations
                    </NavDropdown.Item>
                  )}
                  {hasPermission(userPermissions, '_SECTION_PLATFORM_USERS_') && (
                    <NavDropdown.Item active={currentView === 'platform_users'} onClick={() => setCurrentView('platform_users')}>
                      <i className="bi bi-people me-1"></i> Users
                    </NavDropdown.Item>
                  )}
                  {hasPermission(userPermissions, '_SECTION_UTILIZATION_STATS_') && (
                    <NavDropdown.Item active={currentView === 'utilization_stats'} onClick={() => setCurrentView('utilization_stats')}>
                      <i className="bi bi-bar-chart me-1"></i> Utilization Stats
                    </NavDropdown.Item>
                  )}
                  {hasPermission(userPermissions, '_SECTION_DATA_QUALITY_') && (
                    <NavDropdown.Item active={currentView === 'data_quality'} onClick={() => setCurrentView('data_quality')}>
                      <i className="bi bi-clipboard-data me-1"></i> Data Quality
                    </NavDropdown.Item>
                  )}
                </NavDropdown>
              )}
              {hasModulePermission(userPermissions, '_MODULE_ENTERPRISE_') && (
                <NavDropdown title={<><i className="bi bi-building me-1"></i> Enterprise</>} id="enterprise-dropdown">
                  {hasPermission(userPermissions, '_SECTION_ENTERPRISE_USERS_') && (
                    <NavDropdown.Item active={currentView === 'enterprise_users'} onClick={() => setCurrentView('enterprise_users')}>
                      <i className="bi bi-people me-1"></i> Users
                    </NavDropdown.Item>
                  )}
                  {hasPermission(userPermissions, '_SECTION_ENTERPRISE_ROLES_') && (
                    <NavDropdown.Item active={currentView === 'enterprise_roles'} onClick={() => setCurrentView('enterprise_roles')}>
                      <i className="bi bi-person-badge me-1"></i> Roles
                    </NavDropdown.Item>
                  )}
                  {hasPermission(userPermissions, '_SECTION_ENTERPRISE_TEAMS_') && (
                    <NavDropdown.Item active={currentView === 'enterprise_teams'} onClick={() => setCurrentView('enterprise_teams')}>
                      <i className="bi bi-people-fill me-1"></i> Teams
                    </NavDropdown.Item>
                  )}
                </NavDropdown>
              )}
              {hasModulePermission(userPermissions, '_MODULE_COMMERCIAL_') && (
                <NavDropdown title={<><i className="bi bi-briefcase me-1"></i> Commercial</>} id="financials-dropdown">
                  {hasPermission(userPermissions, '_SECTION_SUBSCRIPTION_') && (
                    <NavDropdown.Item active={currentView === 'subscriptions'} onClick={() => setCurrentView('subscriptions')}>
                      <i className="bi bi-credit-card me-1"></i> Subscriptions
                    </NavDropdown.Item>
                  )}
                  {hasPermission(userPermissions, '_SECTION_OFFERING_') && (
                    <NavDropdown.Item active={currentView === 'offerings'} onClick={() => setCurrentView('offerings')}>
                      <i className="bi bi-box-seam me-1"></i> Offerings
                    </NavDropdown.Item>
                  )}
                  {hasPermission(userPermissions, '_SECTION_SOLUTIONS_') && (
                    <NavDropdown.Item active={currentView === 'solutions'} onClick={() => setCurrentView('solutions')}>
                      <i className="bi bi-puzzle me-1"></i> Solutions
                    </NavDropdown.Item>
                  )}
                </NavDropdown>
              )}
              {hasModulePermission(userPermissions, '_MODULE_FINANCE_') && (
                <NavDropdown title={<><i className="bi bi-currency-dollar me-1"></i> Finance</>} id="finance-dropdown">
                  {hasPermission(userPermissions, '_SECTION_BILLING_') && (
                    <NavDropdown.Item active={currentView === 'billing'} onClick={() => setCurrentView('billing')}>
                      <i className="bi bi-cash-stack me-1"></i> Billing
                    </NavDropdown.Item>
                  )}
                  {hasPermission(userPermissions, '_SECTION_CURRENCIES_') && (
                    <NavDropdown.Item active={currentView === 'currencies'} onClick={() => setCurrentView('currencies')}>
                      <i className="bi bi-coin me-1"></i> Currencies
                    </NavDropdown.Item>
                  )}
                  {hasPermission(userPermissions, '_SECTION_BILLING_CYCLES_') && (
                    <NavDropdown.Item active={currentView === 'billing_cycles'} onClick={() => setCurrentView('billing_cycles')}>
                      <i className="bi bi-arrow-repeat me-1"></i> Billing Cycles
                    </NavDropdown.Item>
                  )}
                  {hasPermission(userPermissions, '_SECTION_COUNTRIES_') && (
                    <NavDropdown.Item active={currentView === 'countries'} onClick={() => setCurrentView('countries')}>
                      <i className="bi bi-globe me-1"></i> Countries
                    </NavDropdown.Item>
                  )}
                  {hasPermission(userPermissions, '_SECTION_FISCAL_ENTITIES_') && (
                    <NavDropdown.Item active={currentView === 'fiscal_entities'} onClick={() => setCurrentView('fiscal_entities')}>
                      <i className="bi bi-bank me-1"></i> Fiscal Entities
                    </NavDropdown.Item>
                  )}
                </NavDropdown>
              )}
              {hasModulePermission(userPermissions, '_MODULE_TECHNOLOGY_') && (

                <NavDropdown title={<><i className="bi bi-gear-wide-connected me-1"></i> Technology</>} id="technology-dropdown">
                  {hasPermission(userPermissions, '_SECTION_DEFAULT_SETTINGS_') && (
                    <li className="dropdown-submenu">
                      <a className="dropdown-item dropdown-toggle" href="#">
                        <span><i className="bi bi-gear me-1"></i>Default Settings</span>
                      </a>
                      <ul className="dropdown-menu">
                        <li className="dropdown-submenu">
                          <a className="dropdown-item dropdown-toggle" href="#">
                            <span><i className="bi bi-sliders me-1"></i>General</span>
                          </a>
                          <ul className="dropdown-menu">
                            <li><a className="dropdown-item" href="#" onClick={(e) => { e.preventDefault(); setCurrentView('user_settings'); }}>
                              <i className="bi bi-person-gear me-1"></i> User Settings
                            </a></li>
                            <li><a className="dropdown-item" href="#" onClick={(e) => { e.preventDefault(); setCurrentView('notification_settings'); }}>
                              <i className="bi bi-bell me-1"></i> Notification Settings
                            </a></li>
                            <li><a className="dropdown-item" href="#" onClick={(e) => { e.preventDefault(); setCurrentView('security_settings'); }}>
                              <i className="bi bi-shield-lock me-1"></i> Security Settings
                            </a></li>
                            <li><a className="dropdown-item" href="#" onClick={(e) => { e.preventDefault(); setCurrentView('platform_access_rights_defaults'); }}>
                              <i className="bi bi-key me-1"></i> Platform Access Rights
                            </a></li>
                          </ul>
                        </li>
                        <li className="dropdown-submenu">
                          <a className="dropdown-item dropdown-toggle" href="#">
                            <span><i className="bi bi-sim me-1"></i>SIM Solution</span>
                          </a>
                          <ul className="dropdown-menu">
                            <li><a className="dropdown-item" href="#" onClick={(e) => { e.preventDefault(); setCurrentView('product_data_defaults'); }}>
                              <i className="bi bi-box-seam me-1"></i> Product Data
                            </a></li>
                            <li><a className="dropdown-item" href="#" onClick={(e) => { e.preventDefault(); setCurrentView('storage_location_types_defaults'); }}>
                              <i className="bi bi-geo-alt me-1"></i> Storage Location Types
                            </a></li>
                            <li><a className="dropdown-item" href="#" onClick={(e) => { e.preventDefault(); setCurrentView('sale_deletion_reasons_defaults'); }}>
                              <i className="bi bi-trash3 me-1"></i> Sale Deletion Reasons
                            </a></li>
                            <li><a className="dropdown-item" href="#" onClick={(e) => { e.preventDefault(); setCurrentView('sale_tag_values_defaults'); }}>
                              <i className="bi bi-tags me-1"></i> Sale Tag Values
                            </a></li>
                            <li><a className="dropdown-item" href="#" onClick={(e) => { e.preventDefault(); setCurrentView('reconciliation_report_types_defaults'); }}>
                              <i className="bi bi-file-earmark-spreadsheet me-1"></i> Reconciliation Report Types
                            </a></li>
                          </ul>
                        </li>
                      </ul>
                    </li>
                  )}
                  {hasPermission(userPermissions, '_SECTION_ACCESS_RIGHTS_') && (
                    <li className="dropdown-submenu">
                      <a className="dropdown-item dropdown-toggle" href="#">
                        <span><i className="bi bi-shield-lock me-1"></i>Access Rights</span>
                      </a>
                      <ul className="dropdown-menu">
                        <li><a className="dropdown-item" href="#" onClick={(e) => { e.preventDefault(); setCurrentView('platform_access_right_management'); }}>
                          <i className="bi bi-cpu me-1"></i> Platform
                        </a></li>
                        <li><a className="dropdown-item" href="#" onClick={(e) => { e.preventDefault(); setCurrentView('enterprise_access_right_management'); }}>
                          <i className="bi bi-building me-1"></i> Enterprise
                        </a></li>
                      </ul>
                    </li>
                  )}
                  {hasPermission(userPermissions, '_SECTION_AUDIT_') && (
                    <li className="dropdown-submenu">
                      <a className="dropdown-item dropdown-toggle" href="#">
                        <span><i className="bi bi-file-text me-1"></i>Login Audit</span>
                      </a>
                      <ul className="dropdown-menu">
                        <li><a className="dropdown-item" href="#" onClick={(e) => { e.preventDefault(); setCurrentView('platform_login_audit'); }}>
                          <i className="bi bi-cpu me-1"></i> Platform
                        </a></li>
                        <li><a className="dropdown-item" href="#" onClick={(e) => { e.preventDefault(); setCurrentView('enterprise_login_audit'); }}>
                          <i className="bi bi-building me-1"></i> Enterprise
                        </a></li>
                        <li><a className="dropdown-item" href="#" onClick={(e) => { e.preventDefault(); setCurrentView('impersonations'); }}>
                          <i className="bi bi-person-badge me-1"></i> Impersonations
                        </a></li>
                      </ul>
                    </li>
                  )}
                  {hasPermission(userPermissions, '_SECTION_SYSTEM_METADATA_') && (
                    <NavDropdown.Item active={currentView === 'system_metadata'} onClick={() => setCurrentView('system_metadata')}>
                      <i className="bi bi-database-gear me-1"></i> System Metadata
                    </NavDropdown.Item>
                  )}
                  <NavDropdown.Divider />
                  {hasPermission(userPermissions, '_SECTION_INFRASTRUCTURE_STATUS_') && (
                    <NavDropdown.Item active={currentView === 'infrastructure_status'} onClick={() => setCurrentView('infrastructure_status')}>
                      <i className="bi bi-hdd-rack me-1"></i> Infrastructure Status
                    </NavDropdown.Item>
                  )}
                </NavDropdown>
              )}
              {hasPermission(userPermissions, '_SECTION_AUDIT_') && (
                <NavDropdown title={<><i className="bi bi-person-vcard me-1"></i> Customer Data</>} id="customer-data-dropdown">
                  <NavDropdown.Item active={currentView === 'archived_records'} onClick={() => setCurrentView('archived_records')}>
                    <i className="bi bi-archive me-1"></i> Archived Records
                  </NavDropdown.Item>
                  <li className="dropdown-submenu">
                    <a className="dropdown-item dropdown-toggle" href="#">
                      <span><i className="bi bi-clock-history me-1"></i>Audit Trail</span>
                    </a>
                    <ul className="dropdown-menu">
                      <li><a className="dropdown-item" href="#" onClick={(e) => { e.preventDefault(); setCurrentView('audit_trail_metadata'); }}>
                        <i className="bi bi-database-gear me-1"></i> Metadata
                      </a></li>
                      <li><a className="dropdown-item" href="#" onClick={(e) => { e.preventDefault(); setCurrentView('audit_trail_master_data'); }}>
                        <i className="bi bi-diagram-3 me-1"></i> Master Data
                      </a></li>
                    </ul>
                  </li>
                </NavDropdown>
              )}
              {hasModulePermission(userPermissions, '_MODULE_DOCUMENTATION_') && (
                <NavDropdown title={<><i className="bi bi-book me-1"></i> Documentation</>} id="documentation-dropdown">
                  {/* <NavDropdown.Item active={currentView === 'documentation_comprehensive'} onClick={() => setCurrentView('documentation_comprehensive')}>
                    <i className="bi bi-building me-1"></i> Comprehensive
                  </NavDropdown.Item>
                  <NavDropdown.Divider /> */}
                  <NavDropdown.Item active={currentView === 'documentation_product_information'} onClick={() => setCurrentView('documentation_product_information')}>
                    <i className="bi bi-box-seam me-1"></i> Product Information
                  </NavDropdown.Item>
                  {hasPermission(userPermissions, '_SECTION_DOCUMENTATION_PRD_') && (
                    <NavDropdown.Item active={currentView === 'documentation_prd'} onClick={() => setCurrentView('documentation_prd')}>
                      <i className="bi bi-file-earmark-text me-1"></i> PRD
                    </NavDropdown.Item>
                  )}
                  <NavDropdown.Item active={currentView === 'documentation_platform'} onClick={() => setCurrentView('documentation_platform')}>
                    <i className="bi bi-cpu me-1"></i> Platform
                  </NavDropdown.Item>
                  <NavDropdown.Item active={currentView === 'documentation_enterprise'} onClick={() => setCurrentView('documentation_enterprise')}>
                    <i className="bi bi-buildings me-1"></i> Enterprise
                  </NavDropdown.Item>
                  <NavDropdown.Item active={currentView === 'documentation_implementation_guide'} onClick={() => setCurrentView('documentation_implementation_guide')}>
                    <i className="bi bi-diagram-3 me-1"></i> Implementation Guide
                  </NavDropdown.Item>
                  <NavDropdown.Item active={currentView === 'documentation_customer_support'} onClick={() => setCurrentView('documentation_customer_support')}>
                    <i className="bi bi-headset me-1"></i> Customer Support
                  </NavDropdown.Item>
                  <NavDropdown.Item active={currentView === 'documentation_legal_compliance'} onClick={() => setCurrentView('documentation_legal_compliance')}>
                    <i className="bi bi-shield-check me-1"></i> Legal &amp; Compliance
                  </NavDropdown.Item>
                  <NavDropdown.Item active={currentView === 'documentation_release_notes'} onClick={() => setCurrentView('documentation_release_notes')}>
                    <i className="bi bi-megaphone me-1"></i> Release Notes
                  </NavDropdown.Item>
                  {hasPermission(userPermissions, '_SECTION_DOCUMENTATION_TECHNICAL_') && (
                    <NavDropdown.Item active={currentView === 'documentation_technical'} onClick={() => setCurrentView('documentation_technical')}>
                      <i className="bi bi-code-square me-1"></i> Technical Information
                    </NavDropdown.Item>
                  )}
                  {hasPermission(userPermissions, '_SECTION_DOCUMENTATION_API_') && (
                    <NavDropdown.Item active={currentView === 'documentation_api_reference'} onClick={() => setCurrentView('documentation_api_reference')}>
                      <i className="bi bi-braces-asterisk me-1"></i> API Reference
                    </NavDropdown.Item>
                  )}
                  <NavDropdown.Divider />
                  <li className="dropdown-submenu">
                    <a className="dropdown-item dropdown-toggle" href="#">
                      <span><i className="bi bi-archive me-1"></i>Archived</span>
                    </a>
                    <ul className="dropdown-menu">
                      <li><a className="dropdown-item" href="#" onClick={(e) => { e.preventDefault(); setCurrentView('documentation_manual'); }}>
                        <i className="bi bi-journal-text me-1"></i> Management Training Manual
                      </a></li>
                      <li><a className="dropdown-item" href="#" onClick={(e) => { e.preventDefault(); setCurrentView('documentation_runbook'); }}>
                        <i className="bi bi-journal-code me-1"></i> Implementation Run Book
                      </a></li>
                    </ul>
                  </li>
                </NavDropdown>
              )}
            </Nav>
            <Nav>
              {/* Version Indicator */}
              {versionInfo && (
                <Nav.Item className="d-flex align-items-center me-3">
                  <VersionIndicator
                    isOutdated={versionInfo.isOutdated}
                    isChecking={versionInfo.isChecking}
                    lastCheckTime={versionInfo.lastCheckTime}
                    onClick={versionInfo.onVersionClick}
                    showBuildNumber={true}
                    size="sm"
                  />
                </Nav.Item>
              )}

              {user && (
                <>
                  <Nav.Link onClick={() => setCurrentView('profile')}>
                    <i className="bi bi-person-circle me-1"></i>
                    {user.name}
                  </Nav.Link>
                  <Nav.Link onClick={handleLogout}>
                    <i className="bi bi-box-arrow-right me-1"></i>
                    Logout
                  </Nav.Link>
                </>
              )}
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
      {process.env.REACT_APP_ENVIRONMENT !== 'production' && process.env.REACT_APP_ENVIRONMENT_WARNING && (
        <Alert variant={process.env.REACT_APP_ENVIRONMENT_WARNING_VARIANT || "warning"} className="mb-0 text-center">
          <i className="bi bi-exclamation-triangle-fill me-2"></i>
          {process.env.REACT_APP_ENVIRONMENT_WARNING}
        </Alert>
      )}
    </>
  );
};

export default AppNavbar;
